import React, { useState, useEffect } from "react";
import ResultCard from "../../components/placement_test/hasil/ResultCard";
import { getTestResult } from "../../hooks/useApi";

const ResultPage = () => {
  const identityId = localStorage.getItem("identity_id");
  const [placementResultId, setPlacementResultId] = useState("");
  const [score, setScore] = useState(null);
  const [level, setLevel] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Responsive tab/folder positioning (desktop vs mobile)
  const [isSmall, setIsSmall] = useState(false);

  useEffect(() => {
    const check = () => setIsSmall(window.innerWidth <= 640);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const QUESTION_TAB_STYLE = isSmall
    ? {
        right: "7rem",
        top: "18px",
        transform: "translateX(-18px) rotate(3deg)",
      }
    : {
        right: "200px",
        top: "28px",
        transform: "translateX(-1rem) rotate(3deg)",
      };

  const RESULT_TAB_STYLE = isSmall
    ? {
        right: "38px",
        top: "38px",
        transform: "translateX(8px)",
      }
    : {
        right: "76px",
        top: "48px",
        transform: "translateX(40px)",
      };

  useEffect(() => {
    const previousBodyBg = document.body.style.backgroundColor;
    const previousHtmlBg = document.documentElement.style.backgroundColor;
    document.body.style.backgroundColor = "var(--st-color-cream)";
    document.documentElement.style.backgroundColor = "var(--st-color-cream)";

    const fetchResult = async () => {
      try {
        const data = await getTestResult();
        setScore(data.result.score);
        setLevel(data.result.level);
        if (data.result.id) {
          setPlacementResultId(String(data.result.id));
        }
        setLoading(false);
      } catch (err) {
        console.error("Gagal fetch hasil tes:", err);
        setError("Gagal memuat hasil tes. Silakan coba lagi.");
        setLoading(false);
      }
    };

    if (identityId) {
      fetchResult();
    } else {
      setError("Identity ID tidak ditemukan. Silakan isi biodata terlebih dahulu.");
      setLoading(false);
    }

    return () => {
      document.body.style.backgroundColor = previousBodyBg;
      document.documentElement.style.backgroundColor = previousHtmlBg;
    };
  }, [identityId]);

  if (loading)
    return (
      <div className="text-center py-20 text-xl font-medium">
        Memuat hasil tes...
      </div>
    );

  if (error)
    return (
      <div className="text-center py-20 text-red-500 text-lg">{error}</div>
    );

  return (
    <div className="min-h-fit bg-[--st-color-cream] overflow-hidden px-4 py-6 sm:py-8">
      <div className="mx-auto w-full max-w-5xl relative font-poppins overflow-visible">
        {/* Back folder layer */}
        <div
          className="pointer-events-none absolute inset-x-0 top-3 z-0 rounded-[30px] bg-[--st-color-program-red] shadow-[0_18px_32px_rgba(0,0,0,0.12)]"
          style={{
            height: isSmall ? "360px" : "520px",
            top: isSmall ? "70px" : "90px",
            transform: isSmall
              ? "translateX(20px) rotate(3deg)"
              : "translateX(28px) rotate(3deg)",
            transformOrigin: "top right",
          }}
          aria-hidden="true"
        />

        {/* tabs */}
        <div className="pointer-events-none absolute inset-x-0 top-0 z-10 h-0 overflow-visible">
          <div className="absolute isolate px-10 sm:px-14 py-3 font-bold z-10 text-[15px] sm:text-[16px] text-white cursor-default" style={QUESTION_TAB_STYLE}>
            <div
              className="absolute inset-0 bg-[--st-color-program-red] z-[-1] shadow-[0_-5px_10px_rgba(0,0,0,0.15)] border-b-0"
              style={{
                transform: "perspective(50px) rotateX(15deg)",
                transformOrigin: "bottom",
                borderRadius: "12px 12px 0 0",
              }}
            />
            <span className="relative z-10 block translate-y-[6px]">Questions</span>
          </div>

          <div className="absolute isolate px-10 sm:px-14 py-3 font-bold z-20 text-[15px] sm:text-[16px] text-[--st-color-program-red] cursor-default" style={RESULT_TAB_STYLE}>
            <div
              className="absolute inset-0 bg-[#FFCE43] z-[-1] shadow-[inset_0_-2px_4px_rgba(0,0,0,0.05)] border-t border-r border-[#E9BC1D] border-b-0"
              style={{
                transform: "perspective(50px) rotateX(15deg)",
                transformOrigin: "bottom",
                borderRadius: "12px 12px 0 0",
              }}
            />
            <span className="relative z-10 block translate-y-[6px]">Result</span>
          </div>
        </div>

        <div className="relative z-10 pt-[78px] sm:pt-[92px]">
          <ResultCard score={score} level={level} placementResultId={placementResultId} />

          {/* WhatsApp CTA below result card */}
          <div className="mt-6 text-center">
              {(() => {
                const waNumber = "6285173272306";
                const msg = `Saya mendapat score ${score} Correct dengan level ${level?.toUpperCase() || 'UNKNOWN'} dari placement test. Bisa tanya-tanya dong tentang langkah selanjutnya!`;
                const href = `https://wa.me/${waNumber}?text=${encodeURIComponent(msg)}`;
                return (
                  <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="st-focus-ring inline-block text-[17px] sm:text-[24px] text-[#444444] font-medium underline underline-offset-2 hover:text-[#176A2A] transition-colors"
                  >
                    Sudah tahu level Bahasa Inggris kamu? Yuk, Tanya Minday!
                  </a>
                );
              })()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultPage;